<template>
  <div class="teams">
    <div class="page__header">
      <div class="page__title">{{ $t(`teamTaxes.${"title"}`) }}</div>
      <div class="page__right">  
        <button class="button button--default" @click="addTax">
          {{ $t(`teamTaxes.${"addTaxBtn"}`) }}
        </button>
      </div>
    </div>

    <div class="table">
      <Loading v-if="teamTaxesLoading" />
      <template v-else>
        <NoData v-if="!teamTaxes.length" :type="'teams'" />
        <template v-else>
          <div class="table__header box box--default">
            <div class="table__label table__label--small team__logo"></div>
            <div class="table__label table__label--large">
              {{ $t(`teamTaxes.${"tableHeader"}.${"team"}`) }}
            </div>
            <div class="table__label table__label--large">
              {{ $t(`teamTaxes.${"tableHeader"}.${"tax_group"}`) }}
            </div>
            <div class="table__label table__label--large">
              {{ $t(`teamTaxes.${"tableHeader"}.${"name"}`) }}
            </div>
            <div class="table__label table__label--medium">
              {{ $t(`teamTaxes.${"tableHeader"}.${"rate"}`) }}
            </div>

            <div
              class="table__label table__label--small"
              v-if="instance.proxy.$checkRolePermission('tax_edit')"
            ></div>
          </div>

          <div class="table__body"> 
            <TeamTax
              v-for="tax in teamTaxes"
              :key="tax.id"
              :tax="tax" 
            />
          </div>
        </template>
      </template>
    </div>

  </div>
</template>

<script setup>
import { computed, onMounted, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Loading from "@/partials/Loading";
import NoData from "@/partials/NoData";
import TeamTax from "@/components/Teams/TeamTax";

const store = useStore();
const route = useRoute();
const instance = getCurrentInstance();

// Computed properties
const teamTaxesLoading = computed(() => store.getters.teamTaxesLoading);
const teamTaxes = computed(() => store.getters.teamTaxes);

// Methods
const addTax = () => {
  store.commit("setTeamTaxToEdit", null);
  store.commit("setTeamTaxIsEdit", false);
  store.commit("setShowAddTeamTaxModal", true);
};

// Lifecycle
onMounted(async () => {
  store.commit("setTeamTaxesLoading", true);
  await store.dispatch("getTeamTaxes", route.params.id);
  store.commit("setTeamTaxesLoading", false);
});
</script>

<style scoped lang="scss">
.teams {
  height: 100%;

  &__button {
    width: 190px;
  }
  .table {
    margin-bottom: 20px;
    height: calc(100% - 40px - 20px - 20px - 30px);
   .table__label--small{
      max-width: 70px;
    }
    &--last {
      max-width: 45px;
      height: initial;
    }
   .team__logo {
     max-width: 70px;
   }
  }
}
</style>
